/*
 *
 * CheckoutStep1Page actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';
import {} from './types';

import ActionTypes from './constants';

export const defaultAction = () => action(ActionTypes.DEFAULT_ACTION);
export const getOrderDraft = createAsyncAction(
  ActionTypes.GET_ORDER_DRAFT_REQUEST,
  ActionTypes.GET_ORDER_DRAFT_SUCCESS,
  ActionTypes.GET_ORDER_DRAFT_FAILURE,
)<void, {}, Error>();

export const updateDeliveryDateTime = (data: any) => action(ActionTypes.UPDATE_DELIVERY_DATE_TIME, data);
export const updateDeliveryNotes = (data: any) => action(ActionTypes.UPDATE_DELIVERY_NOTES, data);
export const addNoteSubmit = (data: any) => action(ActionTypes.ADD_NOTE_SUBMIT, data);

export const refreshOrderDraft = () => action(ActionTypes.REFRESH_ORDER_DRAFT);
